import React from 'react'
import compose from 'recompose/compose'
import {withI18n} from '../../hocs'
import ActionDialog from '../action-dialog'
import * as S from './styled'
import {InputField} from '../../atoms'

const ModalSaveSearch = withI18n(({ i18n, open, handleClose, handleSubmitSave, handleOnChangeTitle, errorMsg }) => {
  return (
    <ActionDialog
      open={open}
      title={i18n.modalSaveSearch.title}
      onClose={handleClose}
      onConfirm={handleSubmitSave}
      cancelLabel={i18n.modalSaveSearch.back}
      confirmLabel={i18n.modalSaveSearch.saveSearch}
      disableBackdropClose
    >
      {/* El form se queda para que Enter en el campo siga guardando */}
      <form onSubmit={handleSubmitSave}>
        <InputField name="searchName" handleOnChange={handleOnChangeTitle} placeholder={i18n.modalSaveSearch.enterName} />
        {errorMsg && <S.ErrorMsg>{errorMsg}</S.ErrorMsg>}
      </form>
    </ActionDialog>
  )
})

const enharce = compose(withI18n)

export default enharce(ModalSaveSearch)
